function selectElementText(el, getSelection, createRange) {
  if (!el) return false;
  if (typeof getSelection !== 'function' || typeof createRange !== 'function') {
    return false;
  }
  const selection = getSelection();
  if (
    !selection ||
    typeof selection.removeAllRanges !== 'function' ||
    typeof selection.addRange !== 'function'
  ) {
    return false;
  }
  const range = createRange();
  if (!range || typeof range.selectNodeContents !== 'function') return false;
  range.selectNodeContents(el);
  selection.removeAllRanges();
  selection.addRange(range);
  return true;
}

module.exports = { selectElementText };
